import {Account} from './account';
import {AdditionalDocument} from './additional-document';
import {Address} from './address';
import {Assets} from './assets';
import {Contact} from './contact';
import {Employment} from './employment';
import {GeneralAgreement} from './general-agreement';
import {Investment} from './investment';
import {Regulatory} from './regulatory';
import {Signature} from './signature';
import {Substitute} from './substitute';
import {AccountType} from './account-type';
import {MonitoringType} from './monitoring-type';
import {IPersonalInfo} from './personal-info';
import {SecondHolder} from './second-holder';
import {UserUtmParameters} from './user-utm-parameters';

export class User implements IPersonalInfo {
  id: number;
  email: string;
  phone: string;
  accessToken: string;
  isWaitingConfirmation: boolean;
  vid: number;
  verificationCode: string;

  firstName: string;

  lastName: string;
  nativeFirstName: string;

  nativeLastName: string;

  gender: string;

  maritalStatus: string;

  numberOfDependents: number;

  customerType: string;

  baseCurrency: string;

  dateOfBirth: string;

  salutation: string;

  applicationStatus: string;

  stockYieldProgram: boolean;

  generalAgreements: Array<GeneralAgreement>;

  accountModel: Account;
  addressModel: Address;
  assetsModel: Assets;
  contactModel: Contact;
  employmentModel: Employment;
  regulatoryModel: Regulatory;
  investmentModel: Investment;
  substituteModel: Substitute;
  userUTMParameters: UserUtmParameters;

  signatureModel: Signature;
  proofIdentetyDocument: AdditionalDocument;
  proofIdentetyBackDocument: AdditionalDocument;
  proofAddressDocument: AdditionalDocument;
  proofAddressBackDocument: AdditionalDocument;
  proofAddressAdditionalDocument: AdditionalDocument;
  documentsNotRequired: boolean;
  ibAccountId: string;
  partnerKey: string;
  timestamp: string;

  purposeIndependent: boolean;
  purposeFixed: boolean;
  accountType: AccountType;
  monitoring: MonitoringType;

  secondHolder: SecondHolder;

  isAdditionalGeneralAgreements: boolean;

  forceCashAccountIE: boolean;
  forceCashAccountUS: boolean;
}
